import React, { useState, useEffect, useContext } from 'react';
import { Mail, X, Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { MessagesContext } from '../MessagesContext';
import { useNavigate } from 'react-router-dom';

const MessageNotification = () => {
  const { t } = useTranslation();
  const { unreadCount, updateUnreadCount } = useContext(MessagesContext);
  const [previousUnreadCount, setPreviousUnreadCount] = useState(0);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const navigate = useNavigate();

  // Überwache Änderungen der unread count
  useEffect(() => {
    if (unreadCount > previousUnreadCount && previousUnreadCount > 0) {
      // Neue Nachricht(en) empfangen
      const newMessages = unreadCount - previousUnreadCount;
      setNotificationMessage(
        newMessages === 1
          ? t("messages.Sie haben eine neue Nachricht erhalten!", "Sie haben eine neue Nachricht erhalten!")
          : t("messages.Sie haben {{count}} neue Nachrichten erhalten!", "Sie haben {{count}} neue Nachrichten erhalten!", { count: newMessages })
      );
      setShowNotification(true);
    }
    setPreviousUnreadCount(unreadCount);
  }, [unreadCount, previousUnreadCount, t]);

  // Automatisches Schließen der Benachrichtigung nach 6 Sekunden
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  const handleNotificationClick = () => {
    setShowNotification(false);
    navigate('/profile/messages');
  };

  const handleCloseNotification = (e) => {
    e.stopPropagation();
    setShowNotification(false);
  };

  return (
    <>
      {/* Floating Message Badge - nur anzeigen wenn ungelesene Nachrichten vorhanden */}
      {unreadCount > 0 && (
        <div
          className="fixed top-20 right-5 z-[50] cursor-pointer animate-in fade-in slide-in-from-right-10 duration-500"
          onClick={handleNotificationClick}
        >
          <div className="relative group">
            <div className="absolute -top-1 -right-1 flex h-6 w-6 z-10">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-6 w-6 bg-rose-500 text-[10px] font-black items-center justify-center text-white border-2 border-white shadow-sm">
                {unreadCount}
              </span>
            </div>
            <div className="w-14 h-14 bg-gradient-to-br from-[#0f7699] to-[#4c9fb9] rounded-2xl flex items-center justify-center text-white shadow-xl group-hover:scale-110 active:scale-95 transition-all duration-300">
              <Mail size={24} />
            </div>
          </div>
        </div>
      )}

      {/* Top Banner Benachrichtigung für neue Nachrichten */}
      {showNotification && (
        <div
          className="fixed top-24 left-1/2 -translate-x-1/2 z-[100] w-[calc(100%-40px)] max-w-lg cursor-pointer animate-in fade-in slide-in-from-top-10 duration-500"
          onClick={handleNotificationClick}
        >
          <div className="bg-[#0f7699] text-white rounded-[1.5rem] p-5 shadow-[0_20px_50px_rgba(15,118,153,0.3)] border border-white/20 flex items-center justify-between group">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center animate-bounce">
                <Bell size={20} />
              </div>
              <div>
                <p className="text-[10px] font-black uppercase tracking-[0.2em] opacity-80 mb-0.5">Neue Nachricht</p>
                <p className="text-sm font-bold tracking-tight">{notificationMessage}</p>
              </div>
            </div>
            <button
              onClick={handleCloseNotification}
              className="p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default MessageNotification;
